export default function Footer(){
  return(
    <footer className="footer">
      <div className="flex justify-center gap-6 mb-4">
      </div>
      <p>© 2026 S4 Technologies</p>
    </footer>
  );
}